<template>
  <WorkTableDialog
    ref="textBlockDialog"
    content-class="contact-address-dialog"
    :headers="headers"
    path="textblocks"
    :handle-row-click="addTextBlock"
    :filter-preset="filterPreset"
    :mandatory-filters="mandatoryFilters"
    :value="cachedTable"
    width="xl"
    height="fs"
    fixed-height
    @input="updateTableFilters"
  >
    <template #header>
      {{ $t('Components.sentences.attachTextblockToComment') }}
    </template>

    <template #search-filters>
      <w-row>
        <w-column
          v-for="(input, index) of inputs"
          :key="index"
          cols="auto"
          class="d-flex flex-grow-1"
        >
          <GenericFilter
            :searchKey="input.model"
            :input="input"
            :look-a-like-filter="cachedTable"
          />
        </w-column>
        <w-column
          cols="auto"
          class="d-flex flex-grow-1"
        >
          <w-multiple-selection-filter-lazy
            :label="$t('TextBlocks.words.textBlockLabel')"
            path="textblocks/label"
            item-text="data.label"
            item-value="id"
            clearable
            :get-data="(response) => response.data.data"
            searchKey="textBlockLabelId"
          />
        </w-column>
      </w-row>
    </template>
    <template #[`item.actions`]="{ item }">
      <w-table-action-wrapper>
        <w-export-button @click="navigateToTextblock(item)">
          <template #tooltip>
            {{ $t('sentences.openTextblock') }}
          </template>
        </w-export-button>
      </w-table-action-wrapper>
    </template>
    <template #append-table-content-below>
      <v-divider style="margin-bottom: 1rem" />
      <WorkTextEditor
        v-model="text"
        reduce-height
        :text-blocks-enabled="false"
        :label="$t('Common.text')"
      />
    </template>

    <template #dialog-actions="{ close, triggerResolve }">
      <w-btn
        outlined
        @click="close"
      >
        {{ $t('Common.cancel') }}
      </w-btn>
      <w-btn @click="saveAndClose(triggerResolve)">
        {{ $t('Common.accept') }} 
      </w-btn>
    </template>
  </WorkTableDialog>
</template>

<script>
import WorkTableDialog from '@/components/base_components/dialog/table_dialogs/WorkTableDialog';
import GenericFilter from '@/components/base_components/generic-relations-wrapper/components/GenericFilter';
import dataMixin from '@/mixins/data-mixin';
import { getFlatInputConfig } from '@/components/base_components/generic-relations-wrapper/configuration/shared-helper-function';
import { noHtmlTagsFormat } from '@/services/format-service';

export default {
  name: 'TextBlockSelectionDialog',
  components: {
    WorkTableDialog,
    GenericFilter,
    WorkTextEditor: () =>
      import('@/components/base_components/editor/WorkTextEditor'),
  },
  props: {
    valueDataPath: { type: String },
    mandatoryFilters: undefined,
    filterPreset: { type: Object },
    removeFilterByResource: { type: Array },
    concept: {type: String, default: 'textBlockDialog' }
  },
  mixins: [
    dataMixin('persistentValue', (self) => self.valueDataPath),
    dataMixin('cachedTable', (self) => `transientData.cachedTables.${self.concept}`),
    dataMixin('resourcesingle', (self) => `transientData.cachedTables.${self.concept}.filters.resourcesingle`)
  ],
  computed: {
    inputs() {
      return getFlatInputConfig('textblock')
        ?.filter(item => !this.removeFilterByResource?.includes(item.model))
    }
  },
  data() {
    return {
      text: undefined,
      headers: [
        {
          text: this.$t('Common.label'),
          value: 'label',
        },
        {
          text: this.$t('Common.textblock'),
          value: 'value',
          presentWith: val => noHtmlTagsFormat(val),
          sortable: false
        },
        {
          text: this.$t('Common.actions'),
          value: 'actions',
          align: 'right',
          sortable: false
        },
        {
          text: this.$t('TextBlocks.words.textBlockLabel'),
          value: 'textBlockLabel'
        },
      ],
      closeDialog: undefined
    };
  },
  methods: {
    open(text) {
      this.text = this.valueDataPath ? this.persistentValue : text;
      this.cachedTable = { filters: this.filterPreset };
      return this.$refs.textBlockDialog.open();
    },
    addTextBlock(item) {
      this.text = !this.text ? item.value : this.text + '\n' + item.value;
    },
    saveAndClose(triggerResolve) {
      if (this.valueDataPath) {
        this.persistentValue = this.text;
        return this.$refs.textBlockDialog.handleRowClickDefault();
      } else triggerResolve(this.text);
    },
    updateTableFilters(event){ 
      this.resourcesingle = event.resourcesingle;
    },
    navigateToTextblock(textblock) {
      let id = textblock.id;
      this.$openUrlInNewTab({
        name: 'TextBlockForm',
        params: { id },
      });
    },
  },
};
</script>

<style lang="scss" scope>
.w-table-dialog.contact-address-dialog .workTableDialog__table {
  display: flex !important;

  .v-data-table {
    flex-grow: 1 !important;
  }

  .append-table-content {
    padding-left: $dialog-content-padding-left;
    padding-right: $dialog-content-padding-right;
    overflow-y: auto;
  }

  .last-selected-row {
    background-color: $last-selected-row-color;
  }
}
</style>
